'use client';

export { ErrorPageSport as default } from '@svs/nova-foundation/nextjs/pages';
